<template>
  <artmisads-modal
    v-model:open="open"
    :title="st('finance.unbindContactModalTitle')"
    :width="480"
    :footer="null"
    :destroyOnClose="true"
    class="unbind-contact-modal-wrap"
  >
    <div class="unbind-contact-modal">
      <p class="desc">{{ st('finance.unbindContactModalContent1') }}</p>
      <p class="desc">{{ st('finance.unbindContactModalContent2') }}</p>
      <div class="qrcode-wrap">
        <img
          class="qrcode"
          src="../../../../../assets/images/social-media-qrcode/wechatApp.png"
          :alt="st('finance.unbindContactModalQrAlt')"
        />
      
      </div>
    </div>
  </artmisads-modal>
</template>

<script setup>
  import { useSellerI18n } from '@/composables/useSellerI18n';

  const { st } = useSellerI18n();
  const open = defineModel('open', { type: Boolean, default: false });
</script>

<style lang="less" scoped>
  .unbind-contact-modal {
    padding-bottom: 8px;
    .desc {
      // margin: 0 0 12px;
      font-size: 14px;
      line-height: 22px;
      color: var(--dark-1);
      text-align: left;
    }
    .qrcode-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 12px;
      .qrcode {
        width: 160px;
        height: 160px;
        object-fit: contain;
      }
      .name {
        margin: 12px 0 0;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: var(--dark-1);
        text-align: center;
      }
    }
  }
</style>
